/* eslint-disable */
import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Extrude from '../../extrude.js';
import Spline from '../spline.js';

export default class NodeExtrudeV2 extends Node
{
	static PLANE_CHOICES =
	[
		{key: 'zy', label: 'Z-Y'},
		{key: 'xy', label: 'X-Y'},
		{key: 'xz', label: 'X-Z'},
	]

	static POSITION_CHOICES =
	[
		{key: 'toShape', label: 'Align with Shape'},
		{key: 'toPath', label: 'Align with Path Start'},
		{key: 'toPathCenter', label: 'Align with Path Center'},
		{key: 'toOrigin', label: 'Center on Origin'},
		{key: 'toOriginBottomAtZero', label: 'Center on Origin, Bottom at Zero'},
	]

	static ALIGN_CHOICES =
	[
		{key: 'center', label: 'Center'},
		{key: 'inside', label: 'Inside Path'},
		{key: 'outside', label: 'Outside Path'},
	]

	static VERT_ALIGN_CHOICES =
	[
		{key: 'center', label: 'Center'},
		{key: 'above', label: 'Above Path'},
		{key: 'below', label: 'Below Path'},
	]

	static BEVEL_SHAPE_CHOICES =
	[
		{key: 'linear', label: 'Linear'},
		{key: 'round', label: 'Round'},
	]

	static SCALING_CHOICES =
	[
		{key: 'scale', label: 'Simple Scale'},
		{key: 'offset', label: 'Intelligent Curve Offsetting'},
	]

	constructor(pParent)
	{
		super(pParent);

		const tempShape = {"points":[{"point":{"x":-0.1,"y":-0.1},"type":0},{"point":{"x":-0.1,"y":0.1},"type":0},{"point":{"x":0.1,"y":0.1},"type":0},{"point":{"x":0.1,"y":-0.1},"type":0}],"isClosed":true};
		const tempPath = { isClosed: false, points: [ { "point": { "x": 0,"y": 0  }, "type": 0 },   {  "point": {  "x": 0,  "y": 1 },  "type": 0 }]};

		this.addInput(PARAM_TYPE.SPLINE, 'shape', tempShape);
		this.addInput(PARAM_TYPE.SPLINE, 'path', tempPath);
		this.addInputsToGroup('Shapes', ['shape', 'path']);

		this.addInput(PARAM_TYPE.DROPDOWN, 'orientation', NodeExtrudeV2.PLANE_CHOICES[1].key, { dropdownOptions: NodeExtrudeV2.PLANE_CHOICES });
		this.addInput(PARAM_TYPE.DROPDOWN, 'position', NodeExtrudeV2.POSITION_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.POSITION_CHOICES });
		this.addInput(PARAM_TYPE.DROPDOWN, 'shape_align_x', NodeExtrudeV2.ALIGN_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.ALIGN_CHOICES });
		this.addInput(PARAM_TYPE.FLOAT, 'shape_align_x_offset', 0.0, { minValue: -0.2, maxValue: 0.2, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.DROPDOWN, 'shape_align_y', NodeExtrudeV2.VERT_ALIGN_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.VERT_ALIGN_CHOICES });
		this.addInput(PARAM_TYPE.FLOAT, 'shape_align_y_offset', 0.0, { minValue: -0.2, maxValue: 0.2, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'smooth_angle', 0.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });
		this.addInput(PARAM_TYPE.BOOLEAN, 'capStart', true);
		this.addInput(PARAM_TYPE.BOOLEAN, 'capEnd', true);
		this.addInput(PARAM_TYPE.BOOLEAN, 'ensure_shape_always_faces_up', false);
		this.addInputsToGroup('Parameters', ['orientation', 'position', 'shape_align_x', 'shape_align_x_offset', 'shape_align_y', 'shape_align_y_offset','smooth_angle', 'capStart', 'capEnd', 'ensure_shape_always_faces_up']);

		this.addInput(PARAM_TYPE.FLOAT, 'scale', 1.0);
		this.addInput(PARAM_TYPE.FLOAT, 'scaleX', 1.0);
		this.addInput(PARAM_TYPE.FLOAT, 'scaleY', 1.0);
		this.addInput(PARAM_TYPE.FLOAT, 'rotate', 0, { minValue: -180, maxValue: 180 });
		this.addInput(PARAM_TYPE.FLOAT, 'start_scale', 1.0);
		this.addInput(PARAM_TYPE.FLOAT, 'end_scale', 1.0);
		this.addInput(PARAM_TYPE.DROPDOWN, 'scale_method', NodeExtrudeV2.SCALING_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.SCALING_CHOICES });
		this.addInputsToGroup('Rotation & Scale', ['scale', 'scaleX', 'scaleY', 'rotate', 'start_scale', 'end_scale', 'scale_method']);

		this.addInput(PARAM_TYPE.FLOAT, 'start_bevel_width', 0.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'start_bevel_scale', 0.0);
		this.addInput(PARAM_TYPE.INTEGER, 'start_bevel_subdivs', 3, { minValue: 1, maxValue: 10 });
		this.addInput(PARAM_TYPE.DROPDOWN, 'start_bevel_shape', NodeExtrudeV2.BEVEL_SHAPE_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.BEVEL_SHAPE_CHOICES });
		this.addInput(PARAM_TYPE.DROPDOWN, 'start_bevel_scale_method', NodeExtrudeV2.SCALING_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.SCALING_CHOICES });
		this.addInputsToGroup('Start Bevel', ['start_bevel_width', 'start_bevel_scale', 'start_bevel_subdivs', 'start_bevel_shape', 'start_bevel_scale_method']);

		this.addInput(PARAM_TYPE.FLOAT, 'end_bevel_width', 0.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'end_bevel_scale', 0.0);
		this.addInput(PARAM_TYPE.INTEGER, 'end_bevel_subdivs', 3, { minValue: 1, maxValue: 10 });
		this.addInput(PARAM_TYPE.DROPDOWN, 'end_bevel_shape', NodeExtrudeV2.BEVEL_SHAPE_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.BEVEL_SHAPE_CHOICES });
		this.addInput(PARAM_TYPE.DROPDOWN, 'end_bevel_scale_method', NodeExtrudeV2.SCALING_CHOICES[0].key, { dropdownOptions: NodeExtrudeV2.SCALING_CHOICES });
		this.addInputsToGroup('End Bevel', ['end_bevel_width', 'end_bevel_scale', 'end_bevel_subdivs', 'end_bevel_shape', 'end_bevel_scale_method']);

		this.addInput(PARAM_TYPE.FLOAT, 'u_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'v_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'uv_rotation', 0.0, { minValue: -180, maxValue: 180, units: PARAM_UNITS.DEGREES });
		this.addInputsToGroup('UV Coordinates', ['u_offset', 'v_offset', 'uv_rotation']);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}
	
	getType()
	{
		return 'extrude_v2';
	}

	getAllowResultCachingSubclass()
	{
		return true;
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let listShape = inputValues['shape'];
		let listPath = inputValues['path'];
		if(!listShape || !listPath)
			return null;

		if(listShape.points.length < 2 || listPath.points.length < 2)
			return null;

		let pShapeSpline = new Spline(listShape);
		if (pShapeSpline.getIs3D())
		{
			// throw Error('Extrusion shape must be a 2D spline - it is currently 3D.');
			console.warn(`Extrusion shape must be a 2D spline - it is currently 3D. Reprojecting to a plane - the result may be incorrect.`);
			let vecNormal = pShapeSpline.getNormal();
			pShapeSpline.projectOntoPlane(vecNormal);
		}

		let pPathSpline = new Spline(listPath);
		
		let capType = BABYLON.Mesh.NO_CAP;
		if(inputValues['capStart'] && inputValues['capEnd'])
			capType = BABYLON.Mesh.CAP_ALL;
		else if(inputValues['capStart'])
			capType = BABYLON.Mesh.CAP_START;
		else if(inputValues['capEnd'])
			capType = BABYLON.Mesh.CAP_END;

		const strPosition = inputValues['position'];

		if(inputValues['scale_method'] === NodeExtrudeV2.SCALING_CHOICES[0].key)
			pShapeSpline.scale(new BABYLON.Vector2(inputValues['scale']*inputValues['scaleX'], -inputValues['scale']*inputValues['scaleY']));
		else
		{
			let vecSize = pShapeSpline.getSize();
			let fDimToUse = Math.max(vecSize.x, vecSize.y)/2.0;
			pShapeSpline.offsetCurve(fDimToUse*(inputValues['scale'] - 1.0));

			// We scale by separate X & Y scales separately because offsets don't support that:
			pShapeSpline.scale(new BABYLON.Vector2(inputValues['scaleX'], -inputValues['scaleY']));
		}

		pShapeSpline.rotate(inputValues['rotate'] + 90);

		let fStartBevelSize = inputValues['start_bevel_width']/100.0;
		let fEndBevelSize = inputValues['end_bevel_width']/100.0;

		if(fStartBevelSize > 0.0)
			pPathSpline = pPathSpline.resampleByNumber(inputValues['start_bevel_subdivs'] + 1, 0.0, fStartBevelSize);
		if(fEndBevelSize > 0.0)
			pPathSpline = pPathSpline.resampleByNumber(inputValues['end_bevel_subdivs'] + 1, 1.0 - fEndBevelSize, 1.0);

		let vecShapePoints = pShapeSpline.getLinearPoints();

		let pMesh = Extrude.createMesh(this.getGeneratedMeshName(), {
				shape: vecShapePoints,
				path: pPathSpline, 
				extrusionPlane: inputValues['orientation'],
				finalMeshAlign: strPosition,
				close: undefined,
				cap: capType,
				uOffset: inputValues['u_offset'],
				vOffset: inputValues['v_offset'],
				uvRotation: inputValues['uv_rotation'],
				flatShaded: true,
				smoothAngle: inputValues['smooth_angle'],
				startScale: inputValues['start_scale'],
				endScale: inputValues['end_scale'],
				scalingMethod: inputValues['scale_method'],
				ensureShapeAlwaysUp: inputValues['ensure_shape_always_faces_up'],

				// We flip X & Y because we rotated the shape above
				shapeAlignY: inputValues['shape_align_x'],
				shapeAlignYOffset: inputValues['shape_align_x_offset'],
				shapeAlignX: inputValues['shape_align_y'],
				shapeAlignXOffset: inputValues['shape_align_y_offset'],

				startBevelWidth: fStartBevelSize,
				startBevelScale: inputValues['start_bevel_scale'],
				startBevelShape: inputValues['start_bevel_shape'],
				startBevelScalingMethod: inputValues['start_bevel_scale_method'],

				endBevelWidth: fEndBevelSize,
				endBevelScale: inputValues['end_bevel_scale'],
				endBevelShape: inputValues['end_bevel_shape'],
				endBevelScalingMethod: inputValues['end_bevel_scale_method'],

			}, scene);

		if(!pMesh)
			return null;

		this.onMeshCreated(pMesh);

		return [pMesh]; 
	}
}